module.exports = __webpack_public_path__ + "static/media/IMG_8108.ccefa453.JPG";